module.exports = __webpack_public_path__ + "media/assets/img/locales/fr_locale_flag-90e6a1e097f7bb27eaab27e694e40300.png";